import moment from 'moment';
import UtcToLocal from '../../../Src/Utils/UtcToLocal';

export default {
    install(app, options) {
        app.config.globalProperties.$formatDate = (date, format = 'YYYY-MM-DD') => {
            return moment(date).format(format);
        };

        app.config.globalProperties.$isExpired = (date) => {
            return Date.parse(date) < new Date();
        };

        app.config.globalProperties.$utcToLocal = UtcToLocal;
    }
}